/* eslint no-undef:0 */
import pageNames from './pageNameIdentifiers';

function getPageDetails(id) {
  return pageNames[id];
}
function trackLink(options) {
  const fpti = {};
  // set link name
  fpti.link = options.link;

  // set page name
  const pageDetails = getPageDetails(options.id);
  fpti.pgrp = pageDetails.pageGroupName;
  fpti.page = pageDetails.pageName;
  fpti.pglk = `${pageDetails.pageGroupName}|${options.link}`;
  fpti.pgln = `${pageDetails.pageName}|${options.link}`;

  // clearing out error props in case they exist
  fpti.erpg = undefined;
  fpti.erfd = undefined;
  fpti.eccd = undefined;

  // setting component
  fpti.comp = 'brcappnodeweb';

  PAYPAL.analytics.Analytics.prototype.recordClick({ data: fpti });
}

function trackPage(options) {
  const fpti = {};
  const pageDetails = getPageDetails(options.id);
  fpti.pgrp = pageDetails.pageGroupName;
  fpti.page = pageDetails.pageName;
  if (options.link) {
    fpti.pglk = `${pageDetails.pageGroupName}|${options.link}`;
    fpti.pgln = `${pageDetails.pageName}|${options.link}`;
  }
  // clearing out error props in case they exist
  fpti.erpg = undefined;
  fpti.erfd = undefined;
  fpti.eccd = undefined;

  // setting component
  fpti.comp = 'brcappnodeweb';
  PAYPAL.analytics.Analytics.prototype.recordImpression({ data: fpti });
}

function trackError(options) {
  const fpti = {};
  // set page name
  const pageDetails = getPageDetails(options.id);
  fpti.pgrp = pageDetails.pageGroupName;
  fpti.page = pageDetails.pageName;

  if (options.errorField) {
    fpti.erpg = pageDetails.pageName;
    fpti.erfd = options.errorField;
  }

  PAYPAL.analytics.Analytics.prototype.recordImpression({ data: fpti });
}

const isRenderingOnClient = () => typeof window !== 'undefined';

const getLaDataLayerInfo = () => {
  if (!isRenderingOnClient() || !window.laDataLayer) return {};
  const { leadGenParam, url } = window.laDataLayer;
  return { leadGenParam, url };
};
const getGoogleClickId = () => {
  if (!isRenderingOnClient() || !document.cookie) return '';
  const cookie = /(?:^|;\s*)gclid=([^;]*)/.exec(document.cookie);
  if (!cookie || !cookie[1]) return '';
  return cookie[1];
};

const getWindowFptiFields = () => {
  if (!isRenderingOnClient() || !window.fpti) return {};
  const { page, pgrp, comp, ccpg, rsta } = window.fpti;
  return {
    page,
    pgrp,
    comp,
    ccpg,
    rsta,
  };
};

const sendFptiData = (param) => {
  if (!isRenderingOnClient() || !window.PAYPAL) return {};
  return window.PAYPAL?.analytics?.instance?.record?.(param);
};

const generateUTMTrackingValues = (leadGenParam) => {
  if (!leadGenParam) return {};
  const utmParams = leadGenParam.split('&');
  const utmFields = utmParams.reduce((prev, curr) => {
    const [utmParam, value] = curr.split('=');
    prev[utmParam] = value;
    return prev;
  }, {});
  return utmFields;
};

const generatePardotTrackingValues = ({
  actionUrl: formHandlerLocation,
  csrfToken: _csrf,
}) => {
  const gclid = getGoogleClickId();
  const { url: webformurl = '', leadGenParam = '' } = getLaDataLayerInfo();
  const utmFields = generateUTMTrackingValues(leadGenParam);
  return {
    _csrf,
    formHandlerLocation,
    webformurl,
    gclid,
    ...utmFields,
  };
};

const recordFormSubmit = ({
  formType,
  isSuccess,
  reason,
  pageURI,
  countryCode,
  userType,
  userLoggedIn,
  userAccountNumber,
  appEntryPoint = 'brc/',
}) => {
  const { page, pgrp, comp, ccpg, rsta } = getWindowFptiFields();
  const trailingSlash = /\/+$/;
  const payloadData = {
    e: 'fs',
    page: `${page}|form_action_submitted`,
    pgrp: `${pgrp}|form_action_submitted`,
    flnm: 'form_submit',
    fltp: formType,
    status: isSuccess ? 'success' : 'error',
    reason: isSuccess ? 'form_validation' : reason,
    cust: ' ',
    mrid: ' ',
    ec: 'form submit',
    ea: `${appEntryPoint?.replace(trailingSlash, '')}/${pageURI}`,
    el: countryCode,
    comp,
    ccpg,
    rsta,
  };
  if (userLoggedIn && userType === 'CONSUMER') {
    payloadData.cust = userAccountNumber;
  } else if (userLoggedIn && userType === 'BUSINESS') {
    payloadData.mrid = userAccountNumber;
  }

  sendFptiData({ data: payloadData });
};

export function getFptiEventForFormSubmit(
  country,
  locale,
  formName,
  status,
  reason,
  page,
  form,
  accountType,
  encryptedNumber,
  formSubmitted,
) {
  const fpti = {};
  fpti.e = 'fs';
  fpti.pgrp = `main:help:brc::${page}`;
  fpti.page = formSubmitted
    ? `${fpti.pgrp}::download-form`
    : `${fpti.pgrp}::form-submit`;
  fpti.link = form;
  fpti.pglk = `${fpti.pgrp}|${fpti.link}`;
  fpti.pgln = `${fpti.page}|${fpti.link}`;
  fpti.comp = 'brcappnodeweb';
  fpti.ec = formSubmitted ? 'Download form' : 'form submit';
  fpti.ea = fpti.pgln;
  fpti.el = country.toUpperCase();
  fpti.rsta = locale;
  fpti.ccpg = country;
  fpti.flnm = formSubmitted ? 'download_form' : 'form_submit';
  fpti.fltp = formName;
  fpti.status = status;
  fpti.reason = reason;
  if (accountType === 'PERSONAL') {
    fpti.cust = encryptedNumber;
    fpti.mrid = '';
  } else if (accountType === 'BUSINESS') {
    fpti.cust = '';
    fpti.mrid = encryptedNumber;
  } else {
    fpti.cust = '';
    fpti.mrid = '';
  }

  PAYPAL.analytics.instance.record({ data: fpti });
}

export {
  trackError,
  trackLink,
  trackPage,
  getGoogleClickId,
  getLaDataLayerInfo,
  generateUTMTrackingValues,
  getWindowFptiFields,
  sendFptiData,
  generatePardotTrackingValues,
  recordFormSubmit,
};
